import styled from 'styled-components';

export const LentilsWrapper = styled.div<{ $count: number }>`
	padding-top: var(--size-dynamic0050);
	padding-bottom: var(--size-dynamic0050);
	display: flex;
	align-items: center;
	flex-direction: column;
	margin-top: var(--size-dynamic0100);

	/* ocultar si todas las slides caben en pantalla */
	${({ $count }) => $count <= 1 && `display: none;`}

	@media (min-width: 960px) {
		${({ $count }) => $count <= 2 && `display: none;`}
	}

	@media (min-width: 1600px) {
		${({ $count }) => $count <= 3 && `display: none;`}
	}

	@media (min-width: 2560px) {
		${({ $count }) => $count <= 4 && `display: none;`}
	}
`;
